import api from "lib/api/api";

export const FETCH_STUDENT_COURSES_REQUEST = "FETCH_STUDENT_COURSES_REQUEST";
export const FETCH_STUDENT_COURSES_SUCCESS = "FETCH_STUDENT_COURSES_SUCCESS";
export const FETCH_STUDENT_COURSES_FAILURE = "FETCH_STUDENT_COURSES_FAILURE";

export const fetchStudentCourses = () => async (dispatch) => {
  dispatch({ type: FETCH_STUDENT_COURSES_REQUEST });
  try {
    const res = await api.get("/admin-developer/student-courses");
    dispatch({ type: FETCH_STUDENT_COURSES_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({
      type: FETCH_STUDENT_COURSES_FAILURE,
      payload: err.message || "Failed to fetch student courses",
    });
  }
};
